import React from 'react';
import Calendar from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const CalendarSharedVacations = React.lazy(() => import('./CalendarSharedVacations'));

const CalendarSharedVacationsPage = () => (
  <Calendar scrolling>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <CalendarSharedVacations />
      </React.Suspense>
    </ErrorBoundary>
  </Calendar>
);

export default CalendarSharedVacationsPage;
